import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Card, CardImg, CardBlock, CardHeader,
  CardTitle, CardSubtitle, Row, Col } from 'reactstrap';
import FileDownload from 'material-ui/svg-icons/file/file-download';
import numeral from 'numeral';
import cn from 'classnames';

import ReviewsLink from 'components/ReviewsLink';

const GeneratorPreview = ({
  heading,
  generatorData,
  image,
  showReviewsLink,
  isAlternate,
  isPortable,
}) => (
  <Card className={cn(
    'generator-preview',
    { 'generator-preview--with-reviews': showReviewsLink },
    { 'generator-preview--is-alternate': isAlternate },
    { 'generator-preview--is-primary': !isAlternate },
  )}
  >
    { heading && <CardHeader className="generator-preview__header">{heading}</CardHeader>}
    <div className="generator-preview__image-wrapper">
      <CardImg className="generator-preview__image" top src={image} alt={generatorData.productName} />
    </div>
    <CardBlock className="card-body generator-preview__body">
      <CardTitle>{generatorData.productName}</CardTitle>
      <CardSubtitle className="generator-preview__subtitle">

        { !!generatorData.basePrice &&
          <span>
            starting at {' '}
            <span className="generator-preview__price">${numeral(generatorData.basePrice).format('0,0')}</span> USD
          </span>
        }
        { !generatorData.basePrice &&
          <span className="generator-preview__request-price">Submit the form below to receive a price quote from your local dealer</span>
        }
        <br />
      </CardSubtitle>
    </CardBlock>
    <CardBlock className="card-body generator-preview__features">
      { !isPortable && (
        <ul className="generator-preview__features-list">
          { !isAlternate && <li>Designed to Be Extremely Quiet</li> }
          <li>Remote Diagnostics Capabilities</li>
          <li>Incredibly Efficient Operation</li>
          <li>Extremely Compact Design</li>
          <li>Designed for Durability</li>
        </ul>)}
      { !!isPortable &&
          (<ul className="generator-preview__features-list">
            {generatorData.portableSpecList.map(item => <li>{item}</li>)}
          </ul>)
      }
      <Row className="generator-preview__ctas">
        { showReviewsLink && <Col><ReviewsLink href="#reviews" /></Col> }
        {
          generatorData.specFile && (
            <Col>
              <div className="text-center">
                <a
                  className="generator-preview__spec-download"
                  href={generatorData.specFile}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FileDownload className="generator-preview__spec-download-icon" /> Download Specs
                </a>
              </div>
            </Col>
          )
        }
      </Row>
      <Row><small className="generator-preview__small-text" style={{ textAlign: 'left', display: 'block', paddingLeft: '20px', paddingTop: '10px' }}>This result is based on an initial estimate of your home’s
        power needs. Your actual needs can best be determined through an
        in-home assessment.</small></Row>
    </CardBlock>
  </Card>
);

GeneratorPreview.propTypes = {
  heading: PropTypes.string,
  generatorData: PropTypes.shape(),
  image: PropTypes.string,
  showReviewsLink: PropTypes.bool,
  isAlternate: PropTypes.bool,
  isPortable: PropTypes.bool,
};

const enhance = compose();

export default enhance(GeneratorPreview);



// WEBPACK FOOTER //
// ./src/components/GeneratorPreview.js